/*
* @Author: zhangzhitao
* @Date: 2019-04-30 10:43:30
 * @Last Modified by: zhenghong7
 * @Last Modified time: 2019-09-16 10:36:41
*/

<template>
  <div class="m-widget-group">
    <span class="u-group-name">{{componentName}}</span>
    <div class="m-widgets-ctn">
      <span
        class="u-widget-tag"
        v-for="(widget,index) in widgets"
        :key="index"
        :class="{disabled: disabled}"
        @mouseover="handleWidgetHover(widget,$event)"
        @mouseout="handlePreviewClose"
        @mousedown="handleDrag(widget,$event)"
      >{{widget.name}}</span>
      <!-- <div
        class="u-virtual-module"
        v-if="virtualWidgetFlag"
        :style="`left:${virtualWidgetPos.x}px;top:${virtualWidgetPos.y}px`"
      >{{activeWidget.name}}</div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'widgets-group',

  props: {
    widgets: {
      type: Array,
      default: () => {
        return []
      }
    },
    componentName: {
      type: String,
      default: () => {
        return ''
      }
    },
    disabled: Boolean
  },

  data () {
    return {

    }
  },

  components: {},

  computed: {},

  mounted () { },

  methods: {
    // 打开预览窗口
    handleWidgetHover (widget, e) {
      this.$emit('preview', widget, e.target.getBoundingClientRect().top)
    },
    // 关闭预览窗口
    handlePreviewClose () {
      this.$emit('preview-close')
    },
    handleDrag (widget, e) {
      if (this.disabled) return
      this.$root.$emit('dragIn', widget, e)
    }
  }
}

</script>

<style lang="less" scoped>
.m-widget-group {
  .u-group-name {
    display: block;
    color: rgba(255, 255, 255, 0.7);
  }
  .m-widgets-ctn {
    padding: 12px 0;
    .u-widget-tag,
    .u-virtual-module {
      display: inline-block;
      max-width: 200px;
      padding: 4px 8px;
      box-sizing: border-box;
      color: #fff;
      background: rgba(255, 255, 255, 0.3);
      border: 1px solid rgba(255, 255, 255, 0);
      margin: 0 8px 8px 0;
      border-radius: 2px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      user-select: none;
      cursor: pointer;
    }
    .u-virtual-module {
      display: block;
      position: absolute;
    }
  }
}
</style>
